import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'app/core/http/api.service';
import { environment as env } from '@env/environment';

import { Router, ActivatedRoute } from '@angular/router';
import { CreditHoursService } from '../../../shared/services/credit-hours.service';

import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AngularFirestore } from '@angular/fire/compat/firestore';
import firebase from 'firebase/compat/app';

@Component({
  selector: 'app-live-test',
  templateUrl: './live.component.html',
  styleUrls: ['./live.component.css'],
})
export class LiveComponent implements OnInit {
  hall: string = '';
  textaraVal: string = '';
  name: string = '';

  userToken: string = '';
  result: any;
  speakers: any;
  questions: any;

  live_type: string = 'youtube';
  youtube: string = '';
  youtube1: string = '';
  youtube2: string = '';
  youtube3: string = '';
  youtube4: string = '';
  youtube5: string = '';
  youtube6: string = '';
  youtube7: string = '';
  youtube8: string = '';
  youtube9: string = '';

  vimeo: string = '';
  vimeo1: string = '';
  vimeo2: string = '';
  vimeo3: string = '';

  uid: string | null = null;

  is_admin = false;
  isGuest = false;
  guestUid: string | null = null;

  conference: any;
  conference_id: string = env.selectedEvent;
  errorMsg = '';

  // NEW: control rendering of the player/stream until consent is given
  consentGiven = false;

  @HostListener('window:unload', ['$event'])
  unloadHandler(_evt: any) {}

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(_evt: any) {}

  constructor(
    
    private cookieService: CookieService,
    private apiServerice: ApiService,
    private router: Router,
    private cme: CreditHoursService,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private afs: AngularFirestore
  ) {
    
    // Read hall from route (supports /live and 
    // /live/:hall)
    const hallParam = this.activatedRoute.snapshot.paramMap.get('hall');
    this.hall = hallParam ?? '';

    // Read guest query params
    const qp = this.activatedRoute.snapshot.queryParamMap;
    const urlUid = qp.get('uid');
    const urlName = qp.get('name'); // optional; dialog will collect if missing

    if (this.cookieService.check('token')) {
      // Authenticated users: keep original behavior
      this.isGuest = false;
      this.userToken = this.cookieService.get('token');
      this.is_admin = Boolean(JSON.parse(this.cookieService.get('is_admin') || 'false'));
      this.consentGiven = true; // logged-in users skip consent popup
    } else if (urlUid) {
      // Guest flow triggered by presence of uid
      this.isGuest = true;
      this.guestUid = urlUid;
      this.name = urlName || ''; // may be empty; dialog will ask for it if needed
      this.userToken = `guest:${urlUid}`;
      // NOTE: we now handle the consent + logging in ngOnInit()
    } else {
      // Missing uid for guest → you can redirect or show message
      this.router.navigate(['/login'], { queryParams: { hall: this.hall || undefined } });
      return;
    }
  }

  async ngOnInit(): Promise<void> {
    this.uid = this.activatedRoute.snapshot.queryParamMap.get('uid');

    if (!this.uid && this.isGuest) {
      this.errorMsg = 'Invalid or missing ID. Please use your personal link.';
    }

    // Optional: small diagnostics write
   
    // ─────────────────────────────────────────────────────────
    // NEW: Consent-on-init flow (guest only)
    // ─────────────────────────────────────────────────────────
    if (this.isGuest && this.guestUid) {
      const localKey = `consent:${this.guestUid}`;
      const cachedConsent = localStorage.getItem(localKey);
      const cachedName = localStorage.getItem(`name:${this.guestUid}`) || '';

      if (cachedConsent) {
        // Previously consented on this browser for this uid
        this.name = this.name || cachedName;
        this.consentGiven = true;

        // Log live touch immediately
        await this.recordLiveTouch(this.guestUid, this.name || 'Guest');
      } else {
        // Open non-dismissible consent dialog
        this.openConsentDialog(this.guestUid, this.name);
        // Note: dialog completion will set consentGiven and perform writes
      }
    }

    // Continue original functionality (gate playback in template with *ngIf="consentGiven")
    this.doConference();
    this.getQuestions();

    setInterval(() => {
      this.getQuestions();
    }, 10000);

    if (!this.isGuest) {
      this.check_in();
      setInterval(() => {
        this.check_out();
      }, 1000 * 60 * 30);
    }
  }

  // ─────────────────────────────────────────────────────────
  // Consent dialog helpers
  // ─────────────────────────────────────────────────────────

openConsentDialog(uid: string, prefillName: string = ''): void {
  const dialogRef = this.dialog.open(ConsentDialogComponent, {
    disableClose: true,             // cannot close without consenting
    width: '520px',
    data: { uid, hall: this.hall || null, name: prefillName || '' },
  });

  dialogRef.afterClosed().subscribe(async (res?: { consent: boolean; name: string }) => {
    // Must have consent + non-empty name, otherwise keep them out
    if (!res || !res.consent || !res.name?.trim()) {
      this.router.navigate(['/login'], {
        queryParams: { uid, hall: this.hall || undefined },
      });
      return;
    }

    this.name = res.name.trim();
    this.consentGiven = true;

    // Remember on this device so we don't ask again for this uid
    localStorage.setItem(`consent:${uid}`, '1');
    localStorage.setItem(`name:${uid}`, this.name);

    try {
      // 1) Record consent + name (firstSeen)
      await this.afs.collection('live_access').doc(uid).set(
        {
          uid,
          name: this.name,
          eventId: this.conference_id,
          consent: true,
          consentAt: firebase.firestore.FieldValue.serverTimestamp(),
          firstSeen: firebase.firestore.FieldValue.serverTimestamp(),
          lastSeen: firebase.firestore.FieldValue.serverTimestamp(),
          lastPath: this.router.url,
          sessions: 0,
        },
        { merge: true }
      );

      // 2) Immediately log this viewing session
      await this.afs.collection('live_access').doc(uid).set(
        {
          uid,
          name: this.name,
          eventId: this.conference_id,
      
          joinedAt: firebase.firestore.FieldValue.serverTimestamp(),
          lastSeen: firebase.firestore.FieldValue.serverTimestamp(),
          lastPath: this.router.url,
          sessions: firebase.firestore.FieldValue.increment(1),
        },
        { merge: true }
      );

      console.log('[live] consent + touch recorded for', uid, this.name);
    } catch (e) {
      console.error('[live] Firestore write FAILED', e);
      this.errorMsg = 'We could not record your consent. Please try again.';
      this.consentGiven = false;
    }
  });
}


  private async recordConsent(uid: string, name: string) {
    try {
      await this.afs.collection('live_access').doc(uid).set(
        {
          uid,
          name,
          eventId: this.conference_id,
          hall: this.hall || null,
          consent: true,
          consentAt: firebase.firestore.FieldValue.serverTimestamp(),
          firstSeen: firebase.firestore.FieldValue.serverTimestamp(),
          lastSeen: firebase.firestore.FieldValue.serverTimestamp(),
          lastPath: this.router.url,
          sessions: 0,
        },
        { merge: true }
      );
    } catch (e) {
      console.error('[live] consent write FAILED', e);
    }
  }

  private async recordLiveTouch(uid: string, name: string) {
    try {
      await this.afs.collection('live_access').doc(uid).set(
        {
          uid,
          name,
          eventId: this.conference_id,
          hall: this.hall || null,
          lastPath: this.router.url,
          joinedAt: firebase.firestore.FieldValue.serverTimestamp(),
          lastSeen: firebase.firestore.FieldValue.serverTimestamp(),
          sessions: firebase.firestore.FieldValue.increment(1),
        },
        { merge: true }
      );
    } catch (e) {
      console.error('[live] live touch FAILED', e);
    }
  }

  // ─────────────────────────────────────────────────────────
  // Existing code
  // ─────────────────────────────────────────────────────────

  scroll(el: HTMLElement) {
    el.scrollIntoView();
  }

  doConference() {
    this.apiServerice.doGet(`conferences/${env.selectedEvent}`).subscribe((res) => {
      this.conference = res;
      this.live_type = this.conference.live_type;

      this.youtube1 = this.conference.youtube1;
      this.youtube2 = this.conference.youtube2;
      this.youtube3 = this.conference.youtube3;
      this.youtube4 = this.conference.youtube4;
      this.youtube5 = this.conference.youtube5;
      this.youtube6 = this.conference.youtube6;
      this.youtube7 = this.conference.youtube7;
      this.youtube8 = this.conference.youtube8;
      this.youtube9 = this.conference.youtube9;

      this.vimeo1 = this.conference.vimeo1;
      this.vimeo2 = this.conference.vimeo2;
      this.vimeo3 = this.conference.vimeo3;
  

      if (this.hall === 'a') {
        this.youtube = this.conference.youtube2;
        this.vimeo = this.conference.vimeo2;
         this.vimeo = this.conference.vimeo1;
      } else {
        this.youtube = this.conference.youtube1;
        this.vimeo = this.conference.vimeo1;
      }
    });
  }

  add_ques(form: any) {
    form.value.token = this.userToken;

    this.apiServerice.doPost(`questions/${env.selectedEvent}`, form.value).subscribe((res) => {
      this.result = res;
    });

    this.textaraVal = '';
  }

  doSpeakers_old() {
    this.apiServerice
      .doGet(`conferences/${env.selectedEvent}/roles/2/members`)
      .subscribe((res) => {
        this.speakers = res;
      });
  }

  check_in() {
    this.cme.check_in('');
  }

  check_out() {
    this.cme.check_out('No');
  }

  goTo(location: string): void {
    window.location.hash = '';
    window.location.hash = location;
  }

  getQuestions() {
    this.apiServerice.doGet(`questions/${env.selectedEvent}`).subscribe((res) => {
      this.questions = res;
    });
  }

  openDialog(d_name: string, d_type = 'image') {
    const dialogRef = this.dialog.open(DialogAddQuestion, {
      data: { name: d_name, type: d_type },
    });

    dialogRef.afterClosed().subscribe((_result) => {});
  }
}

// ─────────────────────────────────────────────────────────
// Consent Dialog Component (inline)
// ─────────────────────────────────────────────────────────
@Component({
  selector: 'app-consent-dialog',
  template: `
    <h2 mat-dialog-title></h2>
    <mat-dialog-content>
      <p class="mb-3">
          <mat-checkbox [(ngModel)]="consent"> </mat-checkbox> *I confirm that I'm a healthcare

provider, resident of Bahrain / Kuwait / Oman / Qatar / United Arab Emirates, who is authorized and

licensed to prescribe and/or handle and/or perform clinical practice in

this(ese) country(ies).
      </p>

      <div class="mb-3">
   
      </div>

      <mat-form-field class="w-100" appearance="fill">
        <mat-label>Full Name</mat-label>
        <input matInput [(ngModel)]="name" />
      </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
      <!-- No cancel button; dialog is disableClose: true -->
      <button mat-flat-button  style="background-color: #e42f13ff; color: white;"
              (click)="confirm()"
              [disabled]="!consent || !name?.trim()">
      Watch Live
      </button>
    </mat-dialog-actions>
  `,
})
export class ConsentDialogComponent {
  consent = false;
  name = '';

  constructor(
    public dialogRef: MatDialogRef<ConsentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { uid: string; hall?: string | null; name?: string }
  ) {
    this.name = data?.name || '';
  }

  confirm() {
    this.dialogRef.close({ consent: this.consent, name: this.name });
  }
}

// ─────────────────────────────────────────────────────────
// Existing DialogAddQuestion (unchanged)
// ─────────────────────────────────────────────────────────
@Component({
  selector: 'dialog-add-question',
  templateUrl: 'dialog-add-question.html',
})
export class DialogAddQuestion {
  name = 'in Dialog';
  type = 'image';
  hall: string = '';
  textaraVal: string = '';

  userToken: string = '';
  conference_id: string = env.selectedEvent;
  result: any;
  speakers: any;

  linkVedio = 'https://player.vimeo.com/video/';

  constructor(
    private apiServerice: ApiService,
    private cookieService: CookieService,
    private activatedRoute: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: { name: string; type: string }
  ) {
    this.name = data.name;
    this.type = data.type;

    this.doSpeakers();

    const qp = this.activatedRoute.snapshot.queryParamMap;
    const qUid = qp.get('uid');
    this.userToken = this.cookieService.get('token') || (qUid ? `guest:${qUid}` : '');

    const hallParam = this.activatedRoute.snapshot.paramMap.get('hall');
    this.hall = hallParam ?? '';
  }

  doSpeakers() {
    this.apiServerice
      .doGet(`conferences/${env.selectedEvent}/today_agenda_speakers`)
      .subscribe((res) => {
        this.speakers = res;
      });
  }

  add_ques(form: any) {
    form.value.token = this.userToken;

    this.apiServerice
      .doPost(`questions/${env.selectedEvent}`, form.value)
      .subscribe((res) => {
        this.result = res;
      });

    this.textaraVal = '';
  }
}
